__turbopack_context__.v({
  "container": "VAK81W_container",
  "icon": "VAK81W_icon",
  "open": "VAK81W_open",
  "optionsButton": "VAK81W_optionsButton",
});
